import { ArrowRight } from "lucide-react";

const DataEngineering = () => {
  return (
    <section id="data-engineering" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row-reverse items-center">
          <div className="md:w-1/2 mb-10 md:mb-0 md:pl-10">
            <h2 className="text-3xl font-bold mb-6">Data Engineering</h2>
            <p className="text-lg text-gray-600 mb-6">
              We design and implement modern data architecture solutions that provide a solid foundation 
              for your analytics and AI initiatives.
            </p>
            
            <div className="bg-gray-50 p-6 rounded-lg mb-6">
              <h3 className="font-semibold text-xl mb-4">Lakehouse Architecture</h3>
              <p className="text-gray-600 mb-4">
                Combining the best of data lakes and data warehouses to create flexible, high-performance 
                data platforms that enable both SQL analytics and machine learning.
              </p>
              <img 
                src="https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&h=225" 
                alt="Data lakehouse architecture" 
                className="rounded-lg w-full" 
                width="400" 
                height="225"
              />
            </div>
            
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="font-semibold text-xl mb-4">Medallion Architecture</h3>
              <p className="text-gray-600 mb-4">
                Multi-layered data organization pattern (Bronze, Silver, Gold) that ensures data quality, 
                governance, and performance at each stage of your data pipeline.
              </p>
              <div className="flex space-x-4">
                <div className="flex flex-col items-center">
                  <div className="w-16 h-16 rounded-full bg-yellow-200 flex items-center justify-center mb-2">
                    <span className="text-yellow-800 font-bold">Bronze</span>
                  </div>
                  <span className="text-sm text-gray-600">Raw Data</span>
                </div>
                <div className="flex items-center">
                  <ArrowRight className="h-5 w-5 text-gray-400" />
                </div>
                <div className="flex flex-col items-center">
                  <div className="w-16 h-16 rounded-full bg-gray-300 flex items-center justify-center mb-2">
                    <span className="text-gray-800 font-bold">Silver</span>
                  </div>
                  <span className="text-sm text-gray-600">Processed</span>
                </div>
                <div className="flex items-center">
                  <ArrowRight className="h-5 w-5 text-gray-400" />
                </div>
                <div className="flex flex-col items-center">
                  <div className="w-16 h-16 rounded-full bg-yellow-500 flex items-center justify-center mb-2">
                    <span className="text-white font-bold">Gold</span>
                  </div>
                  <span className="text-sm text-gray-600">Enriched</span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="md:w-1/2">
            <img 
              src="https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&h=600" 
              alt="Data engineering infrastructure" 
              className="rounded-lg shadow-lg" 
              width="800" 
              height="600"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default DataEngineering;
